<template>
  <v-card>
    <v-card-title primary-title>
      <!-- Company view title -->
      <div v-if="userRoleInCompany >= DEFINES.ROLE_ADMIN">
        <div class="headline secondary--text">
          {{ $t('analytics.company_view.title') }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t('analytics.company_view.subtitle')
        }}</span>
      </div>
    </v-card-title>
    <div>
      <!-- Analytics display -->
      <template v-if="userRoleInCompany >= DEFINES.ROLE_ADMIN">
        <v-tabs
          v-model="currentAnalyticsTab"
          color="grey lighten-4"
          slider-color="primary"
          grow
        >
          <!-- Screening wise analytics tab  -->
          <v-tab href="#event_wise">{{
            $t('analytics.event_wise.title')
          }}</v-tab>
          <!-- Film wise analytics tab -->
          <v-tab href="#film_wise">{{ $t('analytics.film_wise.title') }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="currentAnalyticsTab">
          <v-tab-item value="event_wise">
            <EventUserCount
              v-if="currentAnalyticsTab == 'event_wise'"
              :screening="screening"
            ></EventUserCount
          ></v-tab-item>
          <v-tab-item value="film_wise">
            <FilmUserCount
              v-if="currentAnalyticsTab == 'film_wise'"
              :selectedFilm="selectedFilm"
            >
            </FilmUserCount>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </div>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex';
import EventUserCount from '@/components/chart/EventUserCount';
import FilmUserCount from '@/components/chart/FilmUserCount';

export default {
  name: 'AnalyticsList',
  props: {
    selectedFilm: {
      type: Object,
      default: null,
    },
    screening: {
      type: Object,
      default: null,
    },
    selectedTab: {
      type: String,
      default: 'event_wise',
    },
  },
  data() {
    return {
      currentAnalyticsTab: this.selectedTab,
    };
  },
  components: {
    EventUserCount,
    FilmUserCount,
  },
  computed: {
    ...mapGetters({
      selected_company_id: 'company/getSelected',
    }),
    userRoleInCompany() {
      return this.$store.getters['company/userRoleInCompany'](
        this.selected_company_id
      );
    },
  },
};
</script>

<style></style>
